import { AxiosRequestConfig } from 'axios';
import {
    ALLOWED_PUBLIC_ROUTE_KEYS,
    LeadFormAllowedRouteKeys
} from '~/constants/lead-forms.consts';
import { trackError } from '~/services/logger/error.utils';
import { CXApiService } from '~/components/ClientExperience/services/cx-api.service';
import { IAPIParams } from '~/services/base-api.service';

export class PublicCXApiService extends CXApiService {
    leadFormRouteKey: LeadFormAllowedRouteKeys;

    async apiRequest<T>({
        leadFormRouteKey,
        ...otherOptions
    }: IAPIParams): Promise<T> {
        this.leadFormRouteKey = leadFormRouteKey;
        return super.apiRequest(otherOptions);
    }

    // we don't want to add client to url in public flow
    protected addClientToUrl(url: string): string {
        return url;
    }

    protected requestInterceptor({ url, params, headers, ...config }) {
        const intercepted = super.requestInterceptor({
            url,
            params,
            headers,
            ...config
        });

        // we are in public flow
        return this._publicFilesRequestInterceptor(intercepted);
    }

    protected _publicFilesRequestInterceptor(
        config: AxiosRequestConfig
    ): AxiosRequestConfig {
        const key = this.leadFormRouteKey;
        // this request was made by an endpoint that was explicitly added as allowed in public flows
        if (key && ALLOWED_PUBLIC_ROUTE_KEYS.includes(key)) {
            return config;
        }

        // we shouldn't have arrived here - this means a request was made in a public flow
        // and we did not expect it and do not have an explicit solution for
        const error = new Error('Unexpected http call in PublicCX');
        trackError({
            error,
            context: {
                url: config.url,
                method: config.method,
                leadFormRouteKey: key
            }
        });

        // be silent for now...
        return config;
    }
}
